import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import Meta from "../../helpers/meta";
import BackWithSearch from "../../Mobile/Elements/BackWithSearch";
import AlertList from "./AlertList";
import {
  getUserNotifications,
  markAllNotificationsRead,
  markOneNotificationRead,
} from "../../../services/alert/actions";
import Ink from "react-ink";

const Alerts = ({
  user,
  alerts,
  getUserNotifications,
  markAllNotificationsRead,
  markOneNotificationRead,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.success) return;
    if (!localStorage.getItem("storeColor")) return;

    getUserNotifications(user.data.id, user.data.auth_token);
  }, [user?.success]); // 🔑 only user change triggers fetch

  useEffect(() => {
    if (alerts.length) {
      document.body.classList.add("bg-grey-light");
    }

    return () => {
      document.body.classList.remove("bg-grey-light");
    };
  }, [alerts.length]);

  const handleMarkAllRead = () => {
    if (user.success) {
      markAllNotificationsRead(user.data.id, user.data.auth_token);
    }
  };

  const handleNotificationClick = (alert) => {
    if (user.success) {
      markOneNotificationRead(user.data.id, alert.id, user.data.auth_token).then(() => {
        const data = JSON.parse(alert.data);
        const { unique_order_id, custom_notification, click_action, is_wallet_alert } = data;

        if (unique_order_id) {
          console.log("Order tracking notification");
          navigate(`/running-order/${unique_order_id}`);
        }
        if (custom_notification && click_action) {
          console.log("Custom Notification");
          window.location.href = click_action;
        }
        if (is_wallet_alert) {
          navigate("/my-wallet");
        }
      });
    }
  };

  if (window.innerWidth > 768) {
    return <Navigate to="/" />;
  }
  if (localStorage.getItem("storeColor") === null) {
    return <Navigate to="/" />;
  }
  if (!user.success) {
    return <Navigate to="/login" />;
  }

  return (
    <React.Fragment>
      <Meta
        seotitle={localStorage.getItem("footerAlerts")}
        seodescription={localStorage.getItem("seoMetaDescription")}
        ogtype="website"
        ogtitle={localStorage.getItem("seoOgTitle")}
        ogdescription={localStorage.getItem("seoOgDescription")}
        ogurl={window.location.href}
        twittertitle={localStorage.getItem("seoTwitterTitle")}
        twitterdescription={localStorage.getItem("seoTwitterDescription")}
      />

      <BackWithSearch
        boxshadow={true}
        has_title={true}
        title={localStorage.getItem("footerAlerts")}
        disable_search={true}
      />
      <div className="block-content block-content-full mb-100">
        {alerts.length ? (
          <React.Fragment>
            <button
              className="btn btn-sm btn-clear-alerts float-right mt-50 mb-3"
              style={{ position: "relative" }}
              onClick={handleMarkAllRead}
            >
              {localStorage.getItem("markAllAlertReadText")} <i className="si si-check ml-1" />
              <Ink duration={500} hasTouch={true} />
            </button>
            <div className="clearfix" />
            {alerts.map((alert) => (
              <React.Fragment key={alert.id}>
                <AlertList alert={alert} handleNotificationClick={handleNotificationClick} />
              </React.Fragment>
            ))}
          </React.Fragment>
        ) : (
          <div className="text-center mt-50 font-w600 text-muted pt-100">
            <div className="pb-10">
              <i className="si si-bell" style={{ fontSize: "10rem", color: "#eee" }} />
            </div>
            <p style={{ color: "#ccc" }}>{localStorage.getItem("noNewAlertsText")}</p>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  alerts: state.alert.alerts,
});

export default (connect(mapStateToProps, {
  getUserNotifications,
  markAllNotificationsRead,
  markOneNotificationRead,
})(Alerts));
